import AppLoader from './app-loader';


export default (di) => {
	di
		.setType({type: AppLoader, name: 'AppLoader', parent: 'PageComponent'})
	;
};
